import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconDrink$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconDrink extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'c567a14fce7ecbae67e05731c385b06749be1c68', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '55b6d3a9adefecf5ea13bafa198a46bffe1688ab', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '3c2275c11abbf3754a716734f294e260b155b8a0', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.5 2h-3.123a.5.5 0 0 0-.464.314L12.2 4.106A7.4 7.4 0 0 0 11 4C8.2 4 6 5.5 6 7.411c0 .865.933 8.882.933 8.882C7.108 17.853 8.686 19 10.925 19h.15c2.239 0 3.817-1.147 3.992-2.707 0 0 .933-8.017.933-8.882a3.34 3.34 0 0 0-2.349-2.9l.4-1.015H16.5A.5.5 0 0 0 17 3v-.5a.5.5 0 0 0-.5-.5m-2.932 14.254c-.075.7-1.066 1.246-2.493 1.246h-.15c-1.427 0-2.418-.546-2.493-1.246l-.667-6.242c.99.547 2.104.827 3.235.811a6.5 6.5 0 0 0 3.235-.811zm.954-8.843c0 .9-1.447 1.912-3.522 1.912S7.478 8.315 7.478 7.411 8.925 5.5 11 5.5q.315.003.63.038l-.594 1.494a.5.5 0 0 0 .279.65l.464.186a.5.5 0 0 0 .649-.279L13.1 5.9c.883.378 1.422.962 1.422 1.511", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-drink", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-drink"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-drink":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconDrink$1);
            }
            break;
    } });
}

const CosmosIconDrink = CosmosIconDrink$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconDrink, defineCustomElement };
